{
  "flows": {
    "featureGridMount": {
      "steps": [],
      "trigger": "lifecycle"
    }
  }
}
